import { useState, useEffect, useRef, useCallback } from 'react';
import { ClockContext } from './ClockContext';

const ClockProvider = ( { children } ) => {
  const [ time, setTime ] = useState(new Date());
  const [ color, setColor ] = useState('#840000');
  const [ disco, setDisco ] = useState(false);
  const requestRef = useRef(null);

  const tick = useCallback(() => {
    setTime(new Date());
    requestRef.current = requestAnimationFrame(tick);
  }, []);

  useEffect(() => {
    requestRef.current = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(requestRef.current);
  }, [ tick ]);

  return (
    <ClockContext.Provider value={{ time, color, setColor, disco, setDisco }}>
      {children}
    </ClockContext.Provider>
  );
};

export default ClockProvider;